import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PursueApp } from './pursue/PursueApp';
import './i18n';
import './index.css';

/** Standalone PURSUE site entry — mounts the v2 front at root (base=''). */
const MAIN_SITE = 'https://ufo-watch.pages.dev';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<PursueApp base="" homeHref={MAIN_SITE} />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
